export default "__VITE_ASSET__d18b0996__"